export default {
  path: '/2019TopTenChongqingMerchants',
  name: 'TopTenChongqingMerchants',
  component: () => import('./Home.vue'),
  redirect: '/2019TopTenChongqingMerchants/rules',
  meta: {
    title: '2019年度渝商评选',
  },
  children: [
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: 'Rules',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    {
      path: 'news',
      component: () => import('./RelatedNews.vue'),
      name: 'RelatedNews',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    {
      path: 'applylink',
      component: () => import('./ApplyLink.vue'),
      name: 'ApplyLink',
      meta: {
        title: '2019年度渝商评选',
      },
    },
  ],
};
